<template>
    <div>
        <div class="text-h5 my-3 font-weight-bold">Les inscriptions à {{ mainStore.module.nom }}</div>
        <div> Vous souhaitez vérifier que vous êtes bien inscrit et validé par l'organisation ? Utilisez le formulaire
            ci-dessous. Si vous ne vous trouvez pas, vous êtes probablement encore en phase de préinscription.
        </div>


        <v-row class="mb-4">
            <v-col cols="12" md="6">
                <v-form class="mt-3">
                    <v-text-field v-model="nom" label="Votre nom de famille" />
                    <v-text-field v-model="prenom" label="Votre prénom" />
                    <v-btn color="darkblue" variant="elevated" elevation="0" :disabled="!isFormValid"
                        @click="verify_inscription">Vérifier</v-btn>
                </v-form>
            </v-col>
        </v-row>

        <div v-if="inscriptions.length > 0">
            <div class="mb-3">{{ count_match_query }} résultat(s) pour votre recherche:</div>
            <v-row>
                <v-col cols="12" md="6" v-for="inscription in inscriptions" :key="inscription.id">
                    <div class="spo-card pa-2 rounded">

                        <div class="text-h6">{{ inscription.nom }} {{ inscription.prenom }}
                            <v-icon v-if="inscription.sexe == 'M'" color="primary-dark" icon="mdi-gender-male"></v-icon>
                            <v-icon v-else color="primary-dark" icon="mdi-gender-female"></v-icon>
                        </div>
                        <div>Course : {{ courses_by_id[inscription.id_course] }}</div>
                        <div v-if="inscription.club && inscription.club != ''">Club : {{ inscription.club }}</div>
                        <div v-if="inscription.vague && inscription.vague != ''">SAS de départ : {{ "SAS " +
                            inscription.vague }}</div>

                    </div>
                </v-col>
            </v-row>
        </div>
        <div v-else-if="search_done">Aucun résultat trouvé pour votre recherche</div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PublicService from "@/services/public.service";

export default {
    computed: {
        ...mapStores(useMainStore),
        courses_by_id() {
            let courses = {};
            if (this.mainStore.module.courses.list) {
                this.mainStore.module.courses.list.forEach((course) => {
                    courses[course.id] = course.nom;
                });
            }
            return courses;
        },
        isFormValid() {
            return this.nom.trim() !== "" && this.prenom.trim() !== "";
        }
    },
    data() {
        return {
            search_done: false,
            nom: "",
            prenom: "",
            inscriptions: [],
            update_key: 0,
        }
    },

    methods: {
        async verify_inscription() {

            let params = "";
            params += "id_module=" + this.mainStore.module.id;
            if (this.nom != "") {
                params += "&nom=" + this.nom;
            }
            if (this.prenom != "") {
                params += "&prenom=" + this.prenom;
            }
            let res = await PublicService.getInscriptions(params);

            if (!res) {
                this.update_key++;
                return await false;
            }
            else {
                this.inscriptions = res.list;
                this.count_match_query = res.count_match_query;
                this.update_key++;
                this.search_done = true;
                return await true;
            }



        },
    }
}
</script>

<style lang="scss" scoped></style>